import { debounce } from 'lodash';
import latinize from 'latinize';
import React, { FC, useCallback, useState } from 'react';
import { DropdownInput } from '@src/components/Select/DropdownInput';
import { useGetCountriesLazyQuery } from '@src/graphql/generated';
import { Option } from '@src/components/Select/interfaces/option.interface';
import { CountryLocationDropdownProps } from './props';

export const CountryLocationDropdown: FC<CountryLocationDropdownProps> = ({ defaultValue, onSelect, placeholder }) => {
  const [searchPattern, setSearchPattern] = useState<string>('');

  const [selectedOption, setSelectedOption] = useState<Option | undefined>(defaultValue);

  const [fetchCountries, { data }] = useGetCountriesLazyQuery();

  const options: Option[] =
    data?.countries.result.map(country => {
      return {
        label: country.longName,
        value: country.id,
      };
    }) || [];

  const handleSearch = useCallback(
    debounce((value: string) => {
      fetchCountries({
        variables: {
          paginationOptions: {
            limit: 10,
          },
          searchPattern: encodeURIComponent(latinize(value)),
        },
      });
    }, 300),
    [],
  );

  const handleInputChange = (value: string): void => {
    setSearchPattern(value);

    const trimmedValue = value.trim();

    if (!trimmedValue.length) {
      return;
    }

    handleSearch(trimmedValue);
  };

  return (
    <DropdownInput
      inputValue={searchPattern}
      onInputChange={handleInputChange}
      options={options}
      placeholder={placeholder}
      value={selectedOption}
      onChange={selectedOption => {
        if (!selectedOption) {
          return;
        }

        setSelectedOption(selectedOption);

        onSelect?.(selectedOption);
      }}
    />
  );
};
